import { ForgotPassword } from 'components/forgot-password/ForgotPassword'; //TODO se debe revisar que esta mal escrito el folder. fogot...

export const ForgotPasswordPage = () => {
  return (
    <div>
      <ForgotPassword />
    </div>
  );
};
